import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Box, PaperlessCubeIcon } from '@frontend/components';

import Logo from 'components/Logo/Logo';

import { getHomePage } from 'store/app/selectors';

const connector = connect((state) => ({
  homePage: getHomePage(state),
}));

const HomeNav = ({ homePage, isMicroAppHeader }) => (
  <Box
    as={Link}
    to={homePage}
    cursor="pointer"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    width="auto"
    px={isMicroAppHeader ? 1.5 : 2.5}
  >
    <Box
      display={{
        base: isMicroAppHeader ? 'unset' : 'none',
        desktop: 'unset',
      }}
      width={isMicroAppHeader ? 15 : 21}
    >
      <Box alignSelf="center" width="100%">
        <Logo />
      </Box>
    </Box>
    <Box
      display={{
        base: isMicroAppHeader ? 'none' : 'unset',
        desktop: 'none',
      }}
    >
      <PaperlessCubeIcon
        size={5}
        color="brand.secondary"
        transition="color 0.2s ease"
        _hover={{ color: 'feature.onInteraction' }}
      />
    </Box>
  </Box>
);

export default connector(HomeNav);
